import { gql } from '@apollo/client';
import { apolloClient } from '~/apollo-client';

export const updateSignUpFunnelLead = async (params: UpdateSignupFunnelLeadParams) => {
  const { id, data } = params;
  const query = gql`
    mutation updateSignupFunnelLead($id: Int!, $input: UpdateSignupFunnelLeadInput!) {
      updateSignupFunnelLead(id: $id, input: $input) {
        id
      }
    }
  `;

  const variables = {
    id,
    input: {
      ...data,
    },
  };

  await apolloClient.mutate({
    mutation: query,
    variables,
  });
};

export type UpdateSignupFunnelLeadResponse = {
  id: number;
  status: string;
  [key: string]: any;
};

export interface UpdateSignupFunnelLeadParams {
  id: number;
  data: any;
}
